//项目详情基本信息
import BASE_API from '@/api/dataBase';
// 新增
export const tableCreateColumns = (ctx) => {
  return [
    {
      name: '园区公司',
      prop: 'parkCompany',
      type: 'input',
      disabled: true,
    },
    {
      name: '业务部门',
      prop: 'businessDepartment',
      type: 'input',
      disabled: true,
    },
    {
      name: '操作人',
      prop: 'operatorName',
      type: 'input',
      disabled: true,
    },
    {
      name: '合同类型',
      prop: 'contractTypeName',
      type: 'input',
      disabled: true,
    },
    {
      name: '项目编号',
      prop: 'projectCode',
      type: 'searchTableSpec',
      searchType: 'warehouseContractProject',
      currentValue: ctx.baseInfoData.projectCode,
      disabled: ctx.isProjectToContract || ctx.isChangeContract,
      changeMethod: 'changeMethod',
      isMultiple: true,
    },
    {
      name: '项目名称',
      prop: 'projectName',
      type: 'input',
      disabled: true,
    },
    {
      name: '签约日期',
      prop: 'signingDate',
      type: 'date',
    },
    {
      name: '签约地点',
      prop: 'contractPlace',
      type: 'input',
    },
    {
      name: '合同性质',
      prop: 'contractNatureName',
      // type: 'ajaxSelect',
      disabled: ctx.isProjectToContract || ctx.isChangeContract,
      // apiUrl: BASE_API.DIC_CREDIT_API,
      // apiData: { dictType: 'WAREHOUSE_ADD_PROPERTY' },
      // currentValue: ctx.baseInfoData.contractNatureName,
      type: 'select',
      options: [
        { value: 'PIBT10', label: '双方' },
        { value: 'PIBT11', label: '三方' },
        { value: 'PIBT12', label: '四方' },
      ],
      changeMethod: 'changeMethod',
    },
    {
      name: '开始日期',
      prop: 'dateStart',
      type: 'startDaterangePicker',
    },
    {
      name: '结束日期',
      prop: 'dateEnd',
      type: 'endDaterangePicker',
    },
    {
      name: '仓库名称',
      prop: 'warehouseName',
      type: 'searchTableSpec',
      searchType: 'warehouse',
      extraData: {
        storageDepartmentCode: ctx.departmentCode,
        storageCompanyCode: ctx.companyCode,
      },
      changeMethod: 'changeMethod',
      currentValue: ctx.baseInfoData.warehouseName,
      isMultiple: true,
    },
    {
      name: '仓库公司',
      prop: 'warehouseCompany',
      type: 'input',
      disabled: true,
    },
    {
      name: '商品分类',
      prop: 'productCategoryCode', //
      type: 'select',
      options: ctx.productCategoryList,
      // options: ctx.goodsTypeList,
      // multiple: true,
      changeMethod: 'changeMethod',
    },
    {
      name: '商品名称',
      prop: 'goodsTypeCode', //
      type: 'select',
      options: ctx.goodsTypeList,
      multiple: true,
      changeMethod: 'changeMethod',
    },
    {
      name: '商品品类',
      prop: 'goodsCategoryCode', //
      type: 'select',
      placeholder: '请选择货物品类',
      options: ctx.goodsCategoryList,
      multiple: true,
      changeMethod: 'changeMethod',
    },
    {
      name: '客户1名称(主体)',
      prop: 'customerNameOne',
      type: 'searchTableSpec',
      searchType: 'partner',
      disabled: ctx.isProjectToContract || ctx.isChangeContract,
      extraData: {
        partnerTypes: 'HZHB01',
        departmentCode: ctx.departmentCode,
        companyCode: ctx.companyCode,
      },
      changeMethod: 'changeMethod',
      currentValue: ctx.baseInfoData.customerNameOne,
      isMultiple: true,
      isHidden: !ctx.visibleField.includes('customerNameOne'),
    },
    {
      name: '客户1编码',
      prop: 'customerCodeOne',
      type: 'input',
      disabled: true,
      isHidden: !ctx.visibleField.includes('customerCodeOne'),
    },

    {
      name: '客户1联系人',
      prop: 'customerContactOne',
      type: 'input',
      disabled: ctx.isProjectToContract,
      isHidden: !ctx.visibleField.includes('customerContactOne'),
    },
    {
      name: '客户1联系电话',
      prop: 'contactNumberOne',
      type: 'inputNumber',
      maxlength: 11,
      precision: 0,
      disabled: ctx.isProjectToContract,
      isHidden: !ctx.visibleField.includes('contactNumberOne'),
    },
    {
      name: '联系人1邮箱',
      prop: 'contactEmailOne',
      type: 'input',
      disabled: ctx.isProjectToContract,
      isHidden: !ctx.visibleField.includes('contactEmailOne'),
    },
    {
      name: '客户2名称',
      prop: 'customerNameTwo',
      type: 'searchTableSpec',
      searchType: 'partner',
      disabled: ctx.isProjectToContract || ctx.isChangeContract,
      extraData: {
        partnerTypes: 'HZHB01',
        departmentCode: ctx.departmentCode,
        companyCode: ctx.companyCode,
      },
      changeMethod: 'changeMethod',
      isMultiple: true,
      currentValue: ctx.baseInfoData.customerNameTwo,
      isHidden: !ctx.visibleField.includes('customerNameTwo') && !ctx.baseInfoData.customerNameTwo,
    },
    {
      name: '客户2编码',
      prop: 'customerCodeTwo',
      type: 'input',
      disabled: true,
      isHidden: !ctx.visibleField.includes('customerCodeTwo') && !ctx.baseInfoData.customerNameTwo,
    },
    {
      name: '客户2联系人',
      prop: 'customerContactTwo',
      type: 'input',
      disabled: ctx.isProjectToContract,
      isHidden:
        !ctx.visibleField.includes('customerContactTwo') && !ctx.baseInfoData.customerNameTwo,
    },
    {
      name: '客户2联系电话',
      prop: 'contactNumberTwo',
      type: 'inputNumber',
      disabled: ctx.isProjectToContract,
      maxlength: 11,
      precision: 0,
      placeholder: '请输入联系电话',
      isHidden: !ctx.visibleField.includes('contactNumberTwo') && !ctx.baseInfoData.customerNameTwo,
    },
    {
      name: '联系人2邮箱',
      prop: 'contactEmailTwo',
      type: 'input',
      disabled: ctx.isProjectToContract,
      isHidden: !ctx.visibleField.includes('contactEmailTwo') && !ctx.baseInfoData.customerNameTwo,
    },
    {
      name: '客户3名称',
      prop: 'customerNameThree',
      type: 'searchTableSpec',
      searchType: 'partner',
      disabled: ctx.isProjectToContract || ctx.isChangeContract,
      extraData: {
        partnerTypes: 'HZHB01',
        departmentCode: ctx.departmentCode,
        companyCode: ctx.companyCode,
      },
      changeMethod: 'changeMethod',
      isMultiple: true,
      currentValue: ctx.baseInfoData.customerNameThree,
      isHidden:
        !ctx.visibleField.includes('customerNameThree') && !ctx.baseInfoData.customerNameThree,
    },
    {
      name: '客户3编码',
      prop: 'customerCodeThree',
      type: 'input',
      disabled: true,
      isHidden:
        !ctx.visibleField.includes('customerCodeThree') && !ctx.baseInfoData.customerNameThree,
    },
    {
      name: '客户3联系人',
      prop: 'customerContactThree',
      type: 'input',
      disabled: ctx.isProjectToContract,
      isHidden:
        !ctx.visibleField.includes('customerContactThree') && !ctx.baseInfoData.customerNameThree,
    },
    {
      name: '客户3联系电话',
      prop: 'contactNumberThree',
      type: 'inputNumber',
      maxlength: 11,
      precision: 0,
      disabled: ctx.isProjectToContract,
      placeholder: '请输入联系电话',
      isHidden:
        !ctx.visibleField.includes('contactNumberThree') && !ctx.baseInfoData.customerNameThree,
    },
    {
      name: '联系人3邮箱',
      prop: 'contactEmailThree',
      type: 'input',
      disabled: ctx.isProjectToContract,
      isHidden:
        !ctx.visibleField.includes('contactEmailThree') && !ctx.baseInfoData.customerNameThree,
    },
    {
      name: '收款方式',
      prop: 'paymentMethodName', //
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'receiveMethod' },
    },
    {
      name: '对账日',
      prop: 'reconciliationDate',
      type: 'date',
    },
    {
      name: '计费周期',
      prop: 'billingCycle',
      type: 'input',
    },
    {
      name: '违约金利率',
      prop: 'defaultPenaltyRate',
      type: 'inputNumber',
      maxlength: 5,
      precision: 2,
      min: 0,
      append: '%',
      placeholder: '请输入违约金利率',
    },
    /* {
      name: '纳税人名称',
      prop: 'taxpayerName',
      type: 'input',
    },
    {
      name: '统一社会信用代码',
      prop: 'taxpayerIdentificationNumber',
      type: 'input',
    },
    {
      name: '开户银行',
      prop: 'bankDeposit',
      type: 'searchTableSpec',
      changeMethod: 'changeMethod',
      searchType: 'bank',
      currentValue: ctx.baseInfoData.bankDeposit,
      isMultiple: true,
    },
    {
      name: '银行账号',
      prop: 'bankAccount',
      type: 'inputNumber',
      maxleng: 11,
      precision: 0,
      placeholder: '请输入银行账号',
    }, */
    {
      name: '纸质合同号',
      prop: 'paperContractNo',
      type: 'input',
    },
    {
      name: '签约人',
      prop: 'signatoryName', //
      type: 'input',
    },
    // {
    //   name: '备注',
    //   prop: 'remarks',
    //   type: 'input',
    // },
    {
      name: '备注',
      prop: 'remarks',
      type: 'textarea',
      span: 24,
      maxlength: 500,
    },
  ];
};

// 详情
export const tableDetailColumns = (ctx) => {
  return [
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
      disabled: true,
    },
    {
      name: '园区公司',
      prop: 'parkCompany',
      type: 'input',
      disabled: true,
    },
    {
      name: '业务部门',
      prop: 'businessDepartment',
      type: 'input',
      disabled: true,
    },
    {
      name: '操作人',
      prop: 'operatorName',
      type: 'input',
      disabled: true,
    },
    {
      name: '合同类型',
      prop: 'contractTypeName',
      type: 'input',
      disabled: true,
    },
    {
      name: '项目编号',
      prop: 'projectCode',
      type: 'searchTableSpec',
      searchType: 'warehouseContractProject',
      currentValue: ctx.baseInfoData.projectCode,
      changeMethod: 'changeMethod',
      isMultiple: true,
    },
    {
      name: '项目名称',
      prop: 'projectName',
      type: 'input',
      disabled: true,
    },
    {
      name: '签约日期',
      prop: 'signingDate',
      type: 'date',
    },
    {
      name: '签约地点',
      prop: 'contractPlace',
      type: 'input',
    },
    {
      name: '合同性质',
      prop: 'contractNatureName',
      type: 'select',
      // type: 'ajaxSelect',
      // apiUrl: BASE_API.DIC_CREDIT_API,
      // apiData: { dictType: 'WAREHOUSE_ADD_PROPERTY' },
      options: [
        { value: 'PIBT10', label: '双方' },
        { value: 'PIBT11', label: '三方' },
        { value: 'PIBT12', label: '四方' },
      ],
      changeMethod: 'changeMethod',
    },
    {
      name: '合同状态',
      prop: 'contractStatus',
      type: 'select',
      currentValue: ctx.contractStatus,
      options: ctx.contractStatusList,
      disabled: true,
    },
    {
      name: '合同有效期起',
      prop: 'dateStart',
      type: 'startDaterangePicker',
    },
    {
      name: '合同有效期',
      prop: 'dateEnd',
      type: 'endDaterangePicker',
    },
    {
      name: '纸质合同号',
      prop: 'paperContractNo',
      type: 'input',
    },
    {
      name: '仓库名称',
      prop: 'warehouseName',
      type: 'searchTableSpec',
      searchType: 'warehouse',
      extraData: {
        //departmentCode: ctx.departmentCode,
        companyName: ctx.companyCode,
      },
      changeMethod: 'changeMethod',
      currentValue: ctx.baseInfoData.warehouseName,
      isMultiple: true,
    },
    {
      name: '仓库公司',
      prop: 'warehouseCompany',
      type: 'input',
      disabled: true,
    },
    {
      name: '商品分类',
      prop: 'productCategoryCode', //
      type: 'select',
      options: ctx.productCategoryList,
      // options: ctx.goodsTypeList,
      // multiple: true,
      changeMethod: 'changeMethod',
    },
    {
      name: '商品名称',
      prop: 'goodsTypeCode', //
      type: 'select',
      options: ctx.goodsTypeList,
      multiple: true,
      changeMethod: 'changeMethod',
    },
    {
      name: '商品品类',
      prop: 'goodsCategoryCode', //
      type: 'select',
      placeholder: '请选择货物品类',
      options: ctx.goodsCategoryList,
      disabled: ctx.baseInfoData.goodsTypeCode == null,
      multiple: true,
      changeMethod: 'changeMethod',
    },
    {
      name: '客户1名称(主体)',
      prop: 'customerNameOne',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        partnerTypes: 'HZHB01',
        departmentCode: ctx.departmentCode,
        companyCode: ctx.companyCode,
      },
      changeMethod: 'changeMethod',
      currentValue: ctx.baseInfoData.customerNameOne,
      isMultiple: true,
      isHidden: !ctx.visibleField.includes('customerNameOne'),
    },
    {
      name: '客户1编码',
      prop: 'customerCodeOne',
      type: 'input',
      disabled: true,
      isHidden: !ctx.visibleField.includes('customerCodeOne'),
    },

    {
      name: '客户1联系人',
      prop: 'customerContactOne',
      type: 'input',
      isHidden: !ctx.visibleField.includes('customerContactOne'),
    },
    {
      name: '客户1联系电话',
      prop: 'contactNumberOne',
      type: 'inputNumber',
      maxlength: 11,
      precision: 0,
      isHidden: !ctx.visibleField.includes('contactNumberOne'),
    },
    {
      name: '联系人1邮箱',
      prop: 'contactEmailOne',
      type: 'input',
      isHidden: !ctx.visibleField.includes('contactEmailOne'),
    },
    {
      name: '客户2名称',
      prop: 'customerNameTwo',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        partnerTypes: 'HZHB01',
        departmentCode: ctx.departmentCode,
        companyCode: ctx.companyCode,
      },
      changeMethod: 'changeMethod',
      isMultiple: true,
      currentValue: ctx.baseInfoData.customerNameTwo,
      isHidden: !ctx.visibleField.includes('customerNameTwo'),
    },
    {
      name: '客户2编码',
      prop: 'customerCodeTwo',
      type: 'input',
      disabled: true,
      isHidden: !ctx.visibleField.includes('customerCodeTwo'),
    },
    {
      name: '客户2联系人',
      prop: 'customerContactTwo',
      type: 'input',
      isHidden: !ctx.visibleField.includes('customerContactTwo'),
    },
    {
      name: '客户2联系电话',
      prop: 'contactNumberTwo',
      type: 'inputNumber',
      maxlength: 11,
      precision: 0,
      placeholder: '请输入联系电话',
      isHidden: !ctx.visibleField.includes('contactNumberTwo'),
    },
    {
      name: '联系人2邮箱',
      prop: 'contactEmailTwo',
      type: 'input',
      isHidden: !ctx.visibleField.includes('contactEmailTwo'),
    },
    {
      name: '客户3名称',
      prop: 'customerNameThree',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        partnerTypes: 'HZHB01',
        departmentCode: ctx.departmentCode,
        companyCode: ctx.companyCode,
      },
      changeMethod: 'changeMethod',
      isMultiple: true,
      currentValue: ctx.baseInfoData.customerNameThree,
      isHidden: !ctx.visibleField.includes('customerNameThree'),
    },
    {
      name: '客户3编码',
      prop: 'customerCodeThree',
      type: 'input',
      disabled: true,
      isHidden: !ctx.visibleField.includes('customerCodeThree'),
    },
    {
      name: '客户3联系人',
      prop: 'customerContactThree',
      type: 'input',
      isHidden: !ctx.visibleField.includes('customerContactThree'),
    },
    {
      name: '客户3联系电话',
      prop: 'contactNumberThree',
      type: 'inputNumber',
      maxlength: 11,
      precision: 0,
      placeholder: '请输入联系电话',
      isHidden: !ctx.visibleField.includes('contactNumberThree'),
    },
    {
      name: '联系人3邮箱',
      prop: 'contactEmailThree',
      type: 'input',
      isHidden: !ctx.visibleField.includes('contactEmailThree'),
    },
    {
      name: '付款方式',
      prop: 'paymentMethodName', //
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'receiveMethod' },
    },
    {
      name: '对账日',
      prop: 'reconciliationDate',
      type: 'date',
    },
    {
      name: '计费周期',
      prop: 'billingCycle',
      type: 'input',
    },
    {
      name: '违约金利率',
      prop: 'defaultPenaltyRate',
      type: 'inputNumber',
      maxlength: 5,
      precision: 2,
      append: '%',
      placeholder: '请输入违约金利率',
    },
    {
      name: '签约人',
      prop: 'signatoryName', //
      type: 'input',
    },
    /* {
      name: '纳税人名称',
      prop: 'taxpayerName',
      type: 'input',
    },
    {
      name: '统一社会信用代码',
      prop: 'taxpayerIdentificationNumber',
      type: 'input',
    },
    {
      name: '开户银行',
      prop: 'bankDeposit',
      type: 'searchTableSpec',
      searchType: 'bank',
      changeMethod: 'changeMethod',
      isMultiple: true,
      currentValue: ctx.baseInfoData.bankDeposit,
    },
    {
      name: '银行账号',
      prop: 'bankAccount',
      type: 'inputNumber',
      maxlength: 19,
      precision: 0,
      min: 0,
    }, */
    // {
    //   name: '备注',
    //   prop: 'remarks',
    //   type: 'input',
    // },
    {
      name: '备注',
      prop: 'remarks',
      type: 'textarea',
      span: 24,
      maxlength: 500,
    },
  ];
};
